import { Model } from "../../model";
import { Field } from "./field";

export interface Sector extends Model{
    description: string;
    fields: Field[];
}